import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  buyHelper,
  errorNotice,
  fetching,
  getDefaultFinancements,
  getPageSettings,
  getProductDetails,
  getProductWarranty,
  newDefaultFinancementsv4,
  newProductDetails,
  newProductWarranty,
  setPageSettings,
  toggleHelpDocumenti,
} from '../../../actions/Buy'
import { closeSlackPopUp } from '../../../actions/SlackWebhook'
import { btoaUrlSafe } from '../../../utils/btoa'
import SpinLoader from '../../dumb/SpinLoader'
import FlowBar from '../../FlowBar'
import Metadata from '../../Metadata'
import BackToProductModal from '../../modal/BackToProductModal'
import DocumentiHelperModal from '../../noleggia/dumb/DocumentiHelperModal'
import BuyHeader from '../dumb/BuyHeader'
import ErrorModal from '../dumb/modals/ErrorModal'
import { isFindomestic } from '../utils'

class BuyWrapper extends Component {
  constructor(props) {
    super(props)
    this.state = {
      id_auto: props.id_auto || window.brumbrum.id_auto,
      show_howto_documenti: false,
      showExitModal: false,
    }
    this.handleHelp = this.handleHelp.bind(this)
    this.onLogoClick = this.onLogoClick.bind(this)
  }

  componentDidMount() {
    if (
      !('id_auto' in this.props.product) ||
      this.props.product.id_auto !== this.state.id_auto
    ) {
      this.getInitialData(this.state.id_auto).then(() => {
        this.getInitialDefaultFinancementsv4(this.state.id_auto)
      })
    } else {
      this.getInitialDefaultFinancementsv4(this.state.id_auto)
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.ui.settings.phoneNumber !== prevProps.ui.settings.phoneNumber
    ) {
      // il numero di telefono e' usato nel template twig che ad ora non conviene rifattorizzare
      $("a[href='tel:00390284582']").attr(
        'href',
        this.props.ui.settings.phoneNumber
      )

      /**
       * Bisogna inizializzare dataLayer solo una volta
       * productType e pageType noon dovrebbero cambiare
       * quindi li settiamo solo ad inizializzazione dataLayer
       */
      if (prevProps.ui.settings.phoneNumber === undefined) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ pageType: this.props.ui.settings.pageType })
        window.dataLayer.push({
          productType: this.props.ui.settings.productType,
        })
        window.dataLayer.push({ route: 'Sellout' })
        window.dataLayer.push({ event: 'routeChange' })
      }
    }
  }

  getInitialData(id_auto) {
    const payloadDetails = {
      uri: `${window.brumbrum.url_api}/cms/p/v4/auto/${id_auto}`,
      method: 'POST',
      callback: newProductDetails,
    }

    const payloadWarranty = {
      uri: `${window.brumbrum.url_api}/cms/p/v4/auto/${id_auto}/garanzia`,
      method: 'POST',
      callback: newProductWarranty,
    }

    const payloadPageSettings = {
      uri: `${window.brumbrum.url_api}/cms/p/v4/page-settings/${btoaUrlSafe(
        window.location.pathname
      )}`,
      method: 'GET',
      callback: setPageSettings,
    }

    return Promise.all([
      this.props.getProductDetails(payloadDetails),
      this.props.getProductWarranty(payloadWarranty),
      this.props.getPageSettings(payloadPageSettings),
    ])
  }

  getInitialDefaultFinancementsv4(id_auto) {
    const t = this

    /**
     * BRUM-1968 caricare
     * /cms/p/v4/auto/BR824991/finanziamento
     */
    if (!this.props.ordine.costi_extra && !this.props.ordine.sconto) {
      /**
       * in caso di restore non vanno recuperati se ho costi
       * extra perche' ci pensa il middleware a rieseguire
       * le calcolatrici comprese di costi_extra
       */
      t.props
        .getDefaultFinancements({
          method: 'POST',
          uri: `${window.brumbrum.url_api}/cms/p/v4/auto/${id_auto}/finanziamento`,
          callback: t.props.newDefaultFinancementsv4,
        })
        .then(() => {})
        .catch(() => null)
    }
  }

  handleHelp() {
    this.props.buyHelper()
  }

  onLogoClick() {
    this.setState({
      showExitModal: true,
    })
  }

  render() {
    return (
      <div>
        <Metadata />
        <BuyHeader
          can_sign={
            this.props.findomestic ? this.props.findomestic.can_sign : false
          }
          helper={this.handleHelp}
          last={this.props.last}
          onLogoClick={this.onLogoClick}
          phase={this.props.phase}
          router={this.props.router}
          type={this.props.type}
        />
        <FlowBar {...this.props} flowType={'buy'} router={this.props.router} />
        {this.props.children}
        <ErrorModal
          error={this.props.error}
          errorType={this.props.error.type || 'generic'}
          onClose={this.props.closeSlackPopUp}
          product={this.props.product}
          show={this.props.error.display}
          uuid={this.props.uuid}
        />
        {isFindomestic(this.props.product) ? (
          <SpinLoader ui={this.props.ui} />
        ) : null}

        <DocumentiHelperModal
          display={!!this.props.helpDocumenti}
          onClose={() => {
            this.props.toggleHelpDocumenti(false)
          }}
          variant="simplemodal__popup--full-height simplemodal__popup--full-width"
        />

        {this.state.showExitModal && (
          <BackToProductModal
            koFn={() => this.setState({ showExitModal: false })}
            okFn={() => (window.location.href = `${this.props.product.url}`)}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  phase: state.ui.phase,
  ui: state.ui,
  last: state.ui.last,
  type: state.payment.method,
  findomestic: state.findomestic,
  error: state.error,
  help: state.ui.buyHelper,
  helpDocumenti: state.ui.buyHelperDocumenti,
  product: state.product,
  ordine: state.ordine,
  uuid: state.uuid,
})

export default connect(mapStateToProps, {
  errorNotice,
  fetching,
  getPageSettings,
  getProductDetails,
  getProductWarranty,
  newProductDetails,
  getDefaultFinancements,
  newDefaultFinancementsv4,
  closeSlackPopUp,
  buyHelper,
  toggleHelpDocumenti,
})(BuyWrapper)
